import { render, staticRenderFns } from "./v-instructions-video.vue?vue&type=template&id=9622c128&"
import script from "./v-instructions-video.vue?vue&type=script&lang=js&"
export * from "./v-instructions-video.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports